import useWindowSize from "hooks/useWindowSize";

import envs from "config/envs";

import * as S from "./CnpAssuranceAboutPartnership.style";

const CnpAssuranceAboutPartnership = () => {
  const { width } = useWindowSize();

  return (
    <S.Wrap>
      <S.Content>
        <S.Title variant="headline-02">Uma parceria duradoura</S.Title>
        <S.Paragraph>
          A CNP Seguros Holding Brasil é uma parceria da CNP Assurances com a
          Caixa Seguridade. Essa parceria teve início em 2001, por meio da Caixa
          Seguradora S.A., empresa na qual se iniciou a relação entre a
          acionista francesa CNP Assurances e o Banco CAIXA. Confira o nosso
          organograma societário.
        </S.Paragraph>
      </S.Content>
      <S.Image
        src={
          width < 768
            ? `${envs.HOST_STATIC_CDN}/AreaAberta/Images/holding_cnp_caixa_mobile.webp`
            : `${envs.HOST_STATIC_CDN}/AreaAberta/Images/holding_cnp_caixa.webp`
        }
        alt="Em um organograma, vemos a composição societária das empresas. A Caixa Vida e Previdência é 40% da C N P Assurances e 60% da Caixa Seguridade. A Caixa Consórcio é 25% da C N P Assurances e 75% da Caixa Seguridade."
      />
    </S.Wrap>
  );
};

export default CnpAssuranceAboutPartnership;
